/*
 * @Author: zjt
 * @Email: 13928932429@163.com
 * @Date: 2020-08-06 16:45:55
 * @LastEditTime: 2020-09-27 09:39:04
 * @Description: 复配中心store
 */

import {
    getSacById,
    getSacsList,
    updateSac,
    deleteSac,
    createSac,
    updateSacSales,
    createSacSales,
    updateSacRecipe,
    createSacRecipe,
    getSacRecipeList
} from '@/api/sac'
import Vue from 'vue'

const state = {
    sacsList: [],
    totalCounts: 0,
    sac: {},
}

const getters = {
    getLocalSacById: (state) => (id) => {
        return state.sac.find(x => x._id === id)
    }
}

const actions = {
    async getSacRecipeAction({
        commit
    }, payload) {
        try {
            const recipeList = await getSacRecipeList(payload);
            return recipeList.data
        } catch (error) {
            throw error.message
        }
    },
    async getSacsListAction({
        commit
    }, payload) {
        try {
            const sac = await getSacsList(payload)
            commit('SETSACSLIST', sac.data);
            return sac.data
        } catch (error) {
            throw error.message
        }
    },
    async getSacByIdAction({
        commit
    }, id) {
        try {
            const sac = await getSacById(id)
            commit('SETSAC', sac.data)
            return sac.data
        } catch (error) {
            throw error.message
        }
    },
    async createSacAction({
        commit
    }, payload) {
        try {
            const newSac = await createSac(payload)
            commit('ADDNEWSACLIST', newSac.data)
            return newSac.data
        } catch (error) {
            throw error.message
        }
    },
    async updateSacAction({
        commit
    }, payload) {
        try {
            const sac = await updateSac(payload.id, payload.data);
            commit('UPDATESACLIST', sac.data)
        } catch (error) {
            throw error.message
        }
    },
    async deleteSacAction({
        commit
    }, payload) {
        try {
            await deleteSac(payload.id)
        } catch (error) {
            throw error.message
        }
    },
    async createSacSalesAction({
        commit
    }, payload) {
        try {
            await createSacSales(payload)
        } catch (error) {
            throw error.message
        }
    },
    async updateSacSalesAction({
        commit
    }, payload) {
        try {
            const newSacSales = await updateSacSales(payload.id, payload.data)
            return newSacSales.data
        } catch (error) {
            throw error.message
        }
    },
    async createSacRecipeAction({
        commit
    }, payload) {
        try {
            const recipe = await createSacRecipe(payload);
            return recipe.data
        } catch (error) {
            throw error.message
        }
    },
    async updateSacRecipeAction({
        commit
    }, payload) {
        try {
            const newSacRecipe = await updateSacRecipe(payload.id, payload.data);
            return newSacRecipe.data
        } catch (error) {
            throw error.message
        }
    },
}

const mutations = {
    SETSACSLIST(state, payload) {
        state.sacsList = payload.sacsList;
        state.totalCounts = payload.totalCounts
    },
    SETSAC(state, payload) {
        state.sac = payload;
    },
    ADDNEWSACLIST(state, sac) {
        state.sacsList.unshift(sac)
        state.totalCounts++
    },
    UPDATESACLIST(state, sac) {
        Vue.set(state.sacsList, state.sacsList.findIndex(x => x._id === sac._id), sac)
    },
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}